<template>
  <div>
    <v-dialog v-model="model" max-width="1200" persistent scrollable>
      <material-card
        :title="
          $t(
            'components.plan_fees_configuration.plan_fees_configuration_dialog.edit_{0}',
            [item.Name]
          )
        "
        :color="$vuetify.theme.themes.light.success"
        icon="edit"
        v-if="item"
      >
        <v-card-text>
          <v-form v-model="valid">
            <v-row justify-center>
              <v-col cols="12" sm="12" md="6" lg="3">
                <v-checkbox
                  v-model="item.HasDrawbridgeServices"
                  :label="
                    $t('headers.plan_fees_configuration.drawbridge_services')
                  "
                />
              </v-col>
              <template v-if="item.HasDrawbridgeServices">
                <v-col cols="12" sm="12" md="6" lg="3">
                  <currency-textfield
                    v-model="item.FeePerPerson"
                    :label="
                      $t('headers.plan_fees_configuration.fee_per_person')
                    "
                    :rules="[$rules.requiredNum]"
                    class="required"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="3">
                  <currency-textfield
                    v-model="item.MinimumFeePerBilling"
                    :label="
                      $t(
                        'headers.plan_fees_configuration.minimum_fee_per_billing'
                      )
                    "
                    :rules="[$rules.requiredNum]"
                    class="required"
                  />
                </v-col>
              </template>

              <v-col cols="12" sm="12" md="6" lg="3">
                <v-checkbox
                  v-model="item.HasPBASAdminServices"
                  :label="
                    $t('headers.plan_fees_configuration.pbas_admin_services')
                  "
                />
              </v-col>
              <template v-if="item.HasPBASAdminServices">
                <v-col cols="12" sm="12" md="6" lg="3">
                  <v-checkbox
                    v-model="item.HasClaimsPayment"
                    :label="$t('enums.ClaimsPayment')"
                  />
                </v-col>
                <template v-if="item.HasClaimsPayment">
                  <v-col cols="12" sm="12" md="6" lg="3">
                    <trans-enum
                      :value.sync="item.ClaimsPaymentFeeType"
                      :items="options.Enums.FeeType"
                      :label="
                        $t(
                          'headers.plan_fees_configuration.claims_payment_fee_type'
                        )
                      "
                      :rules="[$rules.required]"
                      class="required"
                    ></trans-enum>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="3">
                    <currency-textfield
                      v-if="item.ClaimsPaymentFeeType === 'Percentage'"
                      v-model="item.ClaimsPaymentFee"
                      :label="
                        $t('headers.plan_fees_configuration.claims_payment_fee')
                      "
                      class="required"
                      :rules="[
                        $rules.requiredNum,
                        $rules.dynamic.maxValue(100),
                      ]"
                      prefix="%"
                    />
                    <currency-textfield
                      v-else
                      v-model="item.ClaimsPaymentFee"
                      :label="
                        $t('headers.plan_fees_configuration.claims_payment_fee')
                      "
                      :rules="[$rules.requiredNum]"
                      class="required"
                    />
                  </v-col>
                </template>
                <v-col cols="12" sm="12" md="6" lg="3">
                  <v-checkbox
                    v-model="item.HasMDMDrugCard"
                    :label="$t('headers.plan_fees_configuration.mdm_drug_card')"
                  />
                </v-col>
                <template v-if="item.HasMDMDrugCard">
                  <v-col cols="12" sm="12" md="6" lg="3">
                    <trans-enum
                      :value.sync="item.MDMTransactionFeeType"
                      :items="options.Enums.FeeType"
                      :label="
                        $t(
                          'headers.plan_fees_configuration.mdm_transaction_fee_type'
                        )
                      "
                      :rules="[$rules.required]"
                      class="required"
                    ></trans-enum>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="3">
                    <currency-textfield
                      v-if="item.MDMTransactionFeeType === 'Percentage'"
                      v-model="item.MDMTransactionFee"
                      :label="
                        $t(
                          'headers.plan_fees_configuration.mdm_transaction_fee'
                        )
                      "
                      class="required"
                      :rules="[
                        $rules.requiredNum,
                        $rules.dynamic.maxValue(100),
                      ]"
                      prefix="%"
                    />
                    <currency-textfield
                      v-else
                      v-model="item.MDMTransactionFee"
                      :label="
                        $t(
                          'headers.plan_fees_configuration.mdm_transaction_fee'
                        )
                      "
                      :rules="[$rules.requiredNum]"
                      class="required"
                    />
                  </v-col>
                </template>
                <v-col cols="12" sm="12" md="6" lg="3">
                  <v-checkbox
                    v-model="item.HasPlanGeneralAdministration"
                    :label="
                      $t(
                        'headers.plan_fees_configuration.plan_general_administration'
                      )
                    "
                  />
                </v-col>
                <template v-if="item.HasPlanGeneralAdministration">
                  <v-col cols="12" sm="12" md="6" lg="3">
                    <currency-textfield
                      v-model="item.GeneralAdministrationFeePerPerson"
                      :label="
                        $t(
                          'headers.plan_fees_configuration.general_administration_fee_per_person'
                        )
                      "
                      :rules="[$rules.requiredNum]"
                      class="required"
                    />
                  </v-col>
                </template>
              </template>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="cancel" :loading="saving">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            @click="save"
            :disabled="!valid"
            :loading="saving"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TransEnum from "@/components/TransEnum.vue";
import ErrorHandler from "@/components/ErrorHandler";
import CurrencyTextfield from "@/components/CurrencyTextfield.vue"
export default {
  components: { TransEnum, ErrorHandler, CurrencyTextfield },
  props: ["model", "value"],
  data() {
    return {
      error: null,
      valid: false,
      item: null,
      saving: false,
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
  },
  watch: {
    model: {
      handler(v) {
        if (v) {
          console.log(this.value);
          if (this.value) {
            this.item = JSON.parse(JSON.stringify(this.value));
          } else {
            this.item = {};
          }
        } else {
          this.item = null;
        }
      },
    },
    value: {
      handler(v) {
        if (v) {
          this.item = JSON.parse(JSON.stringify(v));
        } else {
          this.item = {};
        }
      },
    },
  },
  mounted() {
    if (this.value) {
      this.item = JSON.parse(JSON.stringify(this.value));
    } else {
      this.item = {};
    }
  },
  methods: {
    ...mapActions("plansMembers", ["updatePlanFeeConfiguration"]),
    async save() {
      let payload = JSON.parse(JSON.stringify(this.item));
      delete payload.Id;
      this.saving = true;
      try {
        await this.updatePlanFeeConfiguration({
          planIdentityId: payload.IdentityId,
          payload: payload,
        });
        this.$emit("saved");
        this.item = null;
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    cancel() {
      this.$emit("close");
      this.item = null;
    },
  },
};
</script>
